import { MutationTree } from 'vuex';
import { HistoryItemType, HistoryState } from '@/features/shipment-history/types';

const mutations: MutationTree<HistoryState> = {
  setHistoryItems(state: HistoryState, value: HistoryItemType[]): void {
    state.historyItems = value;
  },
};

export default mutations;
